import classNames from 'classnames';

const withModifier = (base, modifier) => `${base}--${modifier}`;

export function withStatusModifier(className, status, inclusive = true) {
  return classNames({
    [className]: inclusive,
    [withModifier(className, status)]: true,
  });
}
